/// <amd-module name="SuiteCommerce.GiftCertificate.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificate.Model", ["require", "exports", "SuiteCommerce.GiftCertificate.Item.Model", "SuiteCommerce.GiftCertificate.Currency.Model", "SuiteCommerce.GiftCertificate.Common.Utils"], function (require, exports, Item_Model_1, Currency_Model_1, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.GiftCertificateModel = exports.GiftCertificateStatus = void 0;
    var GiftCertificateStatus;
    (function (GiftCertificateStatus) {
        GiftCertificateStatus["active"] = "ACTIVE";
        GiftCertificateStatus["expired"] = "EXPIRED";
        GiftCertificateStatus["inactive"] = "INACTIVE";
        GiftCertificateStatus["invalid"] = "INVALID";
    })(GiftCertificateStatus || (exports.GiftCertificateStatus = GiftCertificateStatus = {}));
    var GiftCertificateModel = /** @class */ (function (_super) {
        __extends(GiftCertificateModel, _super);
        function GiftCertificateModel(attributes) {
            var _this = _super.call(this, attributes) || this;
            _this.urlRoot = '/app/site/hosting/scriptlet.nl?script=customscript_ns_sc_sl_gift_cert_mgmt' +
                '&deploy=customdeploy_ns_sc_sl_gift_cert_mgmt';
            _this.giftcertcode = attributes.giftcertcode || '';
            _this.status = attributes.status || '';
            _this.expirationDate = attributes.expirationDate || '';
            _this.sentOnDate = attributes.sentOnDate || '';
            _this.amountRemaining = attributes.amountRemaining || '';
            _this.amountRemainingFormatted = attributes.amountRemainingFormatted || '';
            _this.originalAmount = attributes.originalAmount || '';
            _this.originalAmountFormatted = attributes.originalAmountFormatted || '';
            _this.sender = attributes.sender || '';
            _this.currency = new Currency_Model_1.CurrencyModel(attributes.currency);
            return _this;
        }
        GiftCertificateModel.prototype.parse = function (data) {
            return GiftCertificateModel.formatGCCurrency(data);
        };
        GiftCertificateModel.formatGCCurrency = function (data) {
            if (!data.currency) {
                data.amountRemainingFormatted = Utils_1.Utils.formatCurrency(data.amountRemaining);
                data.originalAmountFormatted = Utils_1.Utils.formatCurrency(data.originalAmount);
            }
            return data;
        };
        Object.defineProperty(GiftCertificateModel.prototype, "giftcertcode", {
            get: function () {
                return this.get('giftcertcode');
            },
            set: function (giftcertcode) {
                this.set('giftcertcode', giftcertcode);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GiftCertificateModel.prototype, "status", {
            get: function () {
                return this.get('status');
            },
            set: function (status) {
                this.set('status', status);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GiftCertificateModel.prototype, "expirationDate", {
            get: function () {
                return this.get('expirationDate');
            },
            set: function (expirationDate) {
                this.set('expirationDate', expirationDate);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GiftCertificateModel.prototype, "sentOnDate", {
            get: function () {
                return this.get('sentOnDate');
            },
            set: function (sentOnDate) {
                this.set('sentOnDate', sentOnDate);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GiftCertificateModel.prototype, "amountRemaining", {
            get: function () {
                return this.get('amountRemaining');
            },
            set: function (amountRemaining) {
                this.set('amountRemaining', amountRemaining);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GiftCertificateModel.prototype, "amountRemainingFormatted", {
            get: function () {
                return this.get('amountRemainingFormatted');
            },
            set: function (amountRemainingFormatted) {
                this.set('amountRemainingFormatted', amountRemainingFormatted);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GiftCertificateModel.prototype, "originalAmount", {
            get: function () {
                return this.get('originalAmount');
            },
            set: function (originalAmount) {
                this.set('originalAmount', originalAmount);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GiftCertificateModel.prototype, "originalAmountFormatted", {
            get: function () {
                return this.get('originalAmountFormatted');
            },
            set: function (originalAmountFormatted) {
                this.set('originalAmountFormatted', originalAmountFormatted);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GiftCertificateModel.prototype, "sender", {
            get: function () {
                return this.get('sender');
            },
            set: function (sender) {
                this.set('sender', sender);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GiftCertificateModel.prototype, "currency", {
            get: function () {
                return this.get('currency');
            },
            set: function (currency) {
                this.set('currency', currency);
            },
            enumerable: false,
            configurable: true
        });
        GiftCertificateModel.prototype.isRemainingAmountGreaterThanZero = function () {
            return parseInt(this.get('amountRemaining'), 10) > 0;
        };
        GiftCertificateModel.prototype.isActive = function () {
            return this.get('status') === GiftCertificateStatus.active;
        };
        GiftCertificateModel.prototype.isExpired = function () {
            return this.get('status') === GiftCertificateStatus.expired;
        };
        return GiftCertificateModel;
    }(Item_Model_1.ItemModel));
    exports.GiftCertificateModel = GiftCertificateModel;
});
